import React, { useState, useContext } from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TerminalContext } from '../context';
import { MatchPath, UserMenu } from '.';
import * as H from 'history';
import { forEach } from 'lodash';
import { terminalHandlingsPages } from './TerminalHandlings';


//import './NavMenu.css';

//const NavMenu = (props) => {

//}

//export default NavMenu;


type NavMenuLinkProps = {
    children: JSX.Element,
    to: H.LocationDescriptor<H.LocationState> | ((location: H.Location<H.LocationState>) => H.LocationDescriptor<H.LocationState>)
}

const NavMenuLink = ({ to, children }: NavMenuLinkProps) => {
    return <MatchPath to={to} render={(to, match) =>
        <NavItem className={match ? "active" : undefined}>
            <NavLink tag={Link} className="nav-link" to={to}>{children}</NavLink>
        </NavItem>
    } />
}

const NavMenu = () => {
    const { t } = useTranslation('common');
    const { terminal } = useContext(TerminalContext);

    const [collapsed, setCollapsed] = useState(true as boolean);

    const toggleNavbar = () => setCollapsed(!collapsed);

    const navMenuLinks: { to: string, content: JSX.Element }[] = [];

    if (terminal !== null) {
        let terminalSlug = terminal?.slug;

        forEach(terminalHandlingsPages, (page) => {
            navMenuLinks.push({
                to: `/${terminalSlug}/${t(`terminal.${page.key}.slug`)}`,
                content: <>{t(`terminal.${page.key}.link`)}</>
            });
        })

        if (terminal?.port === 'GENOVA') {
            navMenuLinks.push({
                to: `/${terminalSlug}/${t('terminal.storageReport.slug')}`,
                content: <>{t('terminal.storageReport.link')}</>
            });
        }
    }

    return (
        <header>
            <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow" light>
                <NavbarBrand tag={Link} to="/">{t('app.title')}</NavbarBrand>
                <NavbarToggler onClick={toggleNavbar} className="mr-2" />
                <Collapse isOpen={!collapsed} navbar>
                    <div className="d-sm-inline-flex flex-sm-row">
                        {/*<TerminalSelector/>*/}
                        <ul className="navbar-nav flex-grow">
                            {navMenuLinks.map(({ to, content }) => <NavMenuLink key={to} to={to}>{content}</NavMenuLink> )}
                        </ul>
                    </div>
                </Collapse>
                <div className="navbar-right"><UserMenu /></div>
            </Navbar>
        </header>
    );
}


export default NavMenu;